import { OffersTypesApiPaths, OffersTypesComponents } from '@affiliate-cabinet/types'

import { resolveDomain, RestClient } from '../../../utils'

const client = new RestClient(OffersTypesApiPaths.GetApiOffersLoyaltyLevels, {}, resolveDomain(), {
  mode: 'cors',
  referrerPolicy: 'no-referrer',
})

export const getApiOffersLoyaltyLevels = () => client.get<OffersTypesComponents['schemas']['LoyaltyLevels']>('')
